// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_2FIKRq","clearfix":"_266suU","icon":"_3GcjfK","rating-12":"_2YoJLV","rating-15":"_31tY1J","rating-18":"_2WfgLr","rating-pg":"Mx14v9","rating-u":"_3OQo5G"};